interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon';
  showTagline?: boolean;
}

export default function Logo({ className = '', variant = 'full', showTagline = false }: LogoProps) {
  if (variant === 'icon') {
    // SVG icon mark — speech bubble with circuit-pattern checkmark
    return (
      <svg
        className={className}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Speech bubble body */}
        <path
          d="M4 8C4 5.79 5.79 4 8 4H32C34.21 4 36 5.79 36 8V26C36 28.21 34.21 30 32 30H20L12 36V30H8C5.79 30 4 28.21 4 26V8Z"
          fill="#0D9488"
        />
        {/* Circuit traces */}
        <path d="M10 14H14L16 12H22" stroke="white" strokeWidth="0.8" strokeOpacity="0.3" strokeLinecap="round" />
        <path d="M10 18H12L14 20H16" stroke="white" strokeWidth="0.8" strokeOpacity="0.3" strokeLinecap="round" />
        <path d="M28 10V14L26 16V18" stroke="white" strokeWidth="0.8" strokeOpacity="0.3" strokeLinecap="round" />
        <path d="M30 20H28L26 22" stroke="white" strokeWidth="0.8" strokeOpacity="0.3" strokeLinecap="round" />
        <circle cx="10" cy="14" r="1.2" fill="white" fillOpacity="0.25" />
        <circle cx="10" cy="18" r="1.2" fill="white" fillOpacity="0.25" />
        <circle cx="28" cy="10" r="1.2" fill="white" fillOpacity="0.25" />
        <circle cx="30" cy="20" r="1.2" fill="white" fillOpacity="0.25" />
        {/* Checkmark */}
        <path
          d="M14 18L18.5 22.5L28 13"
          stroke="white"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  // Full variant — SVG logo wordmark
  if (showTagline) {
    return (
      <div className={`flex items-center ${className}`}>
        <img
          src="/clarid-logo.svg"
          alt="Clarid™ — Clarity in every communication"
          className="h-full w-auto"
        />
        <span className="text-xs text-slate-500 ml-3">
          Clarity in every communication.
        </span>
      </div>
    );
  }

  return (
    <img
      src="/clarid-logo.svg"
      alt="Clarid™"
      className={className}
    />
  );
}
